import { LeadsReducerState } from './types';

export const initialState: LeadsReducerState = {
  leadDuplicationModal: {
    isOpened: false,
    duplicationsList: [],
    totalAmount: 0,
    newLeadData: null,
  },
  errorMessage: null,
  assignmentInProgress: false,
  qualifyLeadInProgress: false,
  qualifyingLeadError: '',
  disqualifyLeadInProgress: false,
  disqualifyingLeadError: '',
};
